var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8029 47.7983L25.4032 42.198H31.0035L34.8117 38.3898C38.7044 39.746 42.9422 39.7406 46.8314 38.3746C50.7206 37.0085 54.031 34.3628 56.2206 30.8702C58.4103 27.3777 59.3496 23.2454 58.8847 19.1495C58.4199 15.0537 56.5784 11.2369 53.6618 8.32391C50.7452 5.41093 46.9261 3.57427 42.8297 3.11455C38.7332 2.65483 34.602 3.59927 31.1123 5.79329C27.6225 7.98732 24.9809 11.301 23.6197 15.1919C22.2585 19.0829 22.2585 23.3206 23.6195 27.2116L3.00195 47.7983V58.999H14.2026L19.8029 53.3987V47.7983Z",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeWidth: 5.5991,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0052 19.7966C46.5517 19.7966 47.8054 18.5429 47.8054 16.9964C47.8054 15.45 46.5517 14.1963 45.0052 14.1963C43.4588 14.1963 42.2051 15.45 42.2051 16.9964C42.2051 18.5429 43.4588 19.7966 45.0052 19.7966Z",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeWidth: 5.5991,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.560bfc90c90ae154b9c1c455f998785b.svg";
export { ForwardRef as ReactComponent };